import { Injectable } from "@angular/core";
import { CrudService } from "src/app/components/shared/cruds/crud.service";
import { FuncionamientosDTO } from "src/app/models/funcionaminetos.dto";

@Injectable({ providedIn: "root" })
export class FuncionamientoService extends CrudService<FuncionamientosDTO> {
  protected controller: string = "settings/funcionamiento/";
}
